import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import products from "../../../Data/products.json";
import units from "../../../Data/units.json";
import categories from "../../../Data/category.json";
import brands from "../../../Data/brands.json";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_all_products_reports,
  get_fast_moving_products_reports,
  get_products_ageing_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

const ProductAgeingReports = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [total, setTotal] = useState();

  const headers = {
    name: "Products Ageing",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        className: "w-[200px]",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
          { value: 2, label: "Days (Low)" },
          { value: 3, label: "Days (High)" },
          { value: 4, label: "Purchase Qty (Low)" },
          { value: 5, label: "Purchase Qty (High)" },
          { value: 6, label: "Current Stock (Low)" },
          { value: 7, label: "Current Stock (High)" },
          { value: 8, label: "Total Sold (Low)" },
          { value: 9, label: "Total Sold (High)" },
          { value: 10, label: "Movement%  (Low)" },
          { value: 11, label: "Movement% (High)" },
        ],
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        className: "w-[200px]",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        date: tabledata?.date,
        branch: tabledata?.branch,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      // const products = await get_all_products(data);
      const products = await get_products_ageing_reports(data);
      if (products?.status) {
        setBody(products?.data);
        // setTotal(products?.data);

        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div>
          <div className="text-right pb-4">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="bg-white border rounded hover:border-green-500"
                  type="button"
                  size="large"
                >
                  Print <PrinterOutlined className="text-lg" />
                </Button>
              )}
              content={() => componentRef}
            />
          </div>
        </div>

        <table className="w-full bg-white" ref={(el) => (componentRef = el)}>
          <thead className="text-gray-500">
            <tr className="text-sm">
              <td className="border p-4">S.No</td>
              <td className="border p-4">Name</td>
              <td className="border p-4">Batch</td>
              <td className="border p-4">Purchase&nbsp;date</td>
              <td className="border p-4">Days</td>
              <td className="border p-4">Purchase&nbsp;Qty</td>
              <td className="border p-4">Current&nbsp;Stock</td>
              <td className="border p-4">Total&nbsp;Sold</td>
              <td className="border p-4">Movement</td>
            </tr>
          </thead>
          <tbody>
            {body?.map((value, index) => {
              return (
                <tr className="text-xs">
                  <td className="border p-4">{index + 1}</td>
                  <td className="border p-4">{value?.name}</td>
                  <td className="border p-4">{value?.batch}</td>
                  <td className="border p-4">
                    {moment?.(value?.purchase_date)?.format("DD/MM/YYYY")}
                  </td>
                  <td className="border p-4">
                    {value?.days ? value?.days : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.purchase_stock
                      ? Number.isInteger(value?.purchase_stock)
                        ? parseFloat?.(value?.purchase_stock || 0)
                        : parseFloat?.(value?.purchase_stock || 0)?.toFixed(3)
                      : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.current_stock
                      ? Number.isInteger(value?.current_stock)
                        ? parseFloat?.(value?.current_stock || 0)
                        : parseFloat?.(value?.current_stock || 0)?.toFixed(3)
                      : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.total_sold
                      ? Number.isInteger(value?.total_sold)
                        ? parseFloat?.(value?.total_sold || 0)
                        : parseFloat?.(value?.total_sold || 0)?.toFixed(3)
                      : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.movement_percent
                      ? value?.movement_percent + "%"
                      : "0%"}
                  </td>
                </tr>
              );
            })}
          </tbody>

          <tbody>
            <tr className="text-sm">
              <td className="border p-4 text-medium">TOTAL</td>
              <td className="border p-4"></td>
              <td className="border p-4 text-medium"></td>
              <td className="border p-4 text-medium"></td>
              <td className="border p-4 text-medium"></td>
              <td className="border p-4 text-medium"></td>
              <td className="border p-4 text-medium"></td>
              <td className="border p-4 text-medium"></td>
            </tr>
          </tbody>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default ProductAgeingReports;
